<template>
  <div class="d-flex fd-column jc-between">
    <div class="layout flex-0-1 ov-auto">
      <div class="layout-item is-12">
        <div v-if="pro" class="h6 d-flex fd-column flex-center p-x-2 p-t-6:t">
          <pro-avatar
              :size="100"
              :name="pro.service_provider.business_name"
              :id="pro.id"
              :image="pro.service_provider.logo"
              class="flex-0-0 m-b-2"
              selenium="avatar-user-initial-label"/>
          <div class="h4 text-center" selenium="pro-business-name-label">
            {{ pro.service_provider.business_name }}
          </div>
          <router-link
              :to="{
                name: 'pro-public-profile',
                params: { serviceProviderOccupationId: pro.id }
              }"
              class="btn-secondary"
              selenium="view-pro-public-profile-button">
            View Public Profile
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'message-job-info',
  props: {
    job: {
      type: Object,
      required: true,
    },
    skillsProfileId: {
      type: Number,
      required: true,
    },
  },
  data () {
    return {
      confirmationStatus: null,
      modal: null,
      fetchingInfo: false,
    };
  },
  computed: {
    ...mapGetters('dashboard/publicProfile', [
      'getPublicProfileByServiceProviderIdentifierAndOccupationId',
    ]),
    pro () {
      return this.getPublicProfileByServiceProviderIdentifierAndOccupationId(
        this.skillsProfileId,
        this.job.matches[0].occupation_id
      );
    },
  },
  methods: {
    setActiveModal (value) {
      this.modal = value;
    },
    next (payload) {
      if (payload) {
        if (payload.modal) {
          this.setActiveModal(payload.modal);
        } else if (payload.submitted) {
          this.setActiveModal('acknowledge');
          setTimeout(() => {
            this.setActiveModal(null);
          }, 2000);
        }
      } else {
        this.setActiveModal(null);
      }
    },
  },
};
</script>
